<template>
  <div class="align-self-center status">
    <span v-if="status?.value === 'blocked'" class="text-danger">
      <i class="fa fa-times-circle" aria-hidden="true"></i>
    </span>
    <span v-else-if="status?.value === 'validated'" class="text-success">
      <i class="fa fa-check-circle" aria-hidden="true"></i>
    </span>
    <span v-else class="text-warning">
      <i class="fa fa-circle-thin" aria-hidden="true"></i>
    </span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  status: {
    type: Object,
    required: true
  }
})
</script>